import { render } from "./dtwView.vue?vue&type=template&id=2342e120&scoped=true"
import script from "./dtwView.vue?vue&type=script&lang=js"
export * from "./dtwView.vue?vue&type=script&lang=js"

import "./dtwView.vue?vue&type=style&index=0&id=2342e120&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2342e120"]])

export default __exports__